import React from 'react';

export type Ordering = 'tag' | 'alphabetical';

interface IProjectContext {
  searchTerm: string;
  setSearchTerm: React.Dispatch<React.SetStateAction<string>>;
  orderType: Ordering;
  setOrderType: React.Dispatch<React.SetStateAction<Ordering>>;
  filterTag?: string;
  setFilterTag: React.Dispatch<React.SetStateAction<string | undefined>>;
}

const ProjectContext = React.createContext<IProjectContext>(
  null as unknown as IProjectContext,
);

export default ProjectContext;

export const useProjectContext = () => {
  const context = React.useContext(ProjectContext);
  if (context === null)
    throw new Error('useProjectContext must be used within a ProjectProvider');
  return context;
};
